<template>
  <div class="download">
    <!-- <transition name="test">
      <div class="wechat" v-if="checkIsWechat">
        <div class="tips">
          点击右上角按钮，然后在弹出的菜单中，点击在浏览器中打开即可
        </div>
        <img src="../assets/images/link.png" class="icon" />
      </div>
    </transition> -->
    <div class="page">
      <div class="head">
        <img src="../assets/images/logo.png" />
        <div class="name">爪玩</div>
        <div class="sub-title">世界那么大，我想去爪玩～</div>
      </div>
      <div class="btn" id="btn">打开APP</div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.init()
  },
  methods: {
    init() {
      var data = OpenInstall.parseUrlParams() ///openinstall.js中提供的工具函数，解析url中的所有查询参数
      new OpenInstall(
        {
          appKey: 'x29emf',
          /*OpenInstall初始化完成的回调函数，可选*/
          onready: function() {
            /*在app已安装的情况尝试拉起app*/
            this.schemeWakeup()

            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            const button = document.getElementById('btn')
            const _this = this
            button.onclick = function() {
              _this.wakeupOrInstall()
              return false
            }
          },
        },
        data,
      )
    },
  },
}
</script>

<style lang="less" scoped>
.download {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  .wechat {
    padding: 0 20px;
    background-color: #323334;
    display: flex;
    align-items: flex-start;
    .tips {
      font-size: 14px;
      color: #818283;
      line-height: 25px;
      padding: 25px 0;
    }
    .icon {
      display: block;
      width: 25px;
      height: 30px;
      margin-top: 10px;
    }
  }
  .page {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .head {
      text-align: center;
      img {
        width: 80px;
        height: 80px;
        background: #fff;
        padding: 10px;
        border-radius: 12px;
      }
      .name {
        font-size: 40px;
        margin: 20px 0;
        color: #515151;
      }
      .sub-title {
        font-size: 14px;
        color: #9e9e9e;
      }
    }
    .btn {
      color: #fff;
      background: #f57f20;
      width: 160px;
      text-align: center;
      padding: 10px 20px;
      border-radius: 25px;
      font-size: 16px;
    }
  }
}
.test-enter-active {
  animation: test 10s;
}
@keyframes test {
  0% {
    transform: translateY(0%);
  }
  50% {
    transform: translateY(50%);
  }
  100% {
    transform: translateY(100%);
  }
}
</style>
